import styled, { keyframes } from 'styled-components';

import { FlexCenterAligned } from '@/styled/common';

const rotation = keyframes`
  100%{transform: rotate(1turn)}
`;

export const LoaderContainer = styled(FlexCenterAligned)<{
  $isFull?: boolean;
}>`
  width: 100%;
  height: ${({ $isFull }) => $isFull && '100vh'};
`;

export const LoaderSpinner = styled.div`
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: ${({
    theme
  }) => `radial-gradient(farthest-side, ${theme.text.main} 94%, transparent) top / 3px 3px no-repeat,
    radial-gradient(farthest-side, ${theme.text.main} 94%, transparent) bottom / 3px 3px no-repeat,
    linear-gradient(to right, ${theme.text.main} 50%, white 50%)`};
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 3px), #000 0);
  mask: radial-gradient(farthest-side, #0000 calc(100% - 3px), #000 0);
  animation: ${rotation} 1s infinite linear;
`;
